/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class InternalOrdersRoute extends Route {
  // Services
  @service
  store;

  model() {
    return this.store.findAll('finance/internal-order');
  }
}
